import { fetchResource, postResource, putResource } from '@/services/fetchService.js'

class UserService {
  constructor() {
    this.type = ''
  }

  fetchUserTenants = async (id) => {
    const userId = id.toLowerCase()
    const tenants = await fetchResource(`user/${userId}/tenants`)
    return tenants
  }

  fetchUser = async (id) => {
    const userId = id.toLowerCase()
    const user = await fetchResource(`user/${userId}`)
    return user
  }

  addUser = async (user) => {
    const userCopy = { ...user }
    userCopy.userId = user.userId.toLowerCase()
    const newUser = await postResource('user', userCopy)
    return newUser
  }

  updateUser = async (user) => {
    const userCopy = { ...user }
    userCopy.userId = user.userId.toLowerCase()
    const updatedUser = putResource(`user/${userCopy.userId}`, userCopy)
    return updatedUser
  }

  verifyUser = async (id) => {
    const userId = id.toLowerCase()
    const response = await fetchResource(`user/${userId}?verify=true`)
    return response.exists
  }
}

export default UserService
export const userService = new UserService()
